import { FC } from "react";
import IFrame from "./IFrame";

interface GmuFrameProps {
  source: string;
}

const GmuFrame: FC<GmuFrameProps> = ({ source }) => {
  const sandBoxAttr: string =
    "allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups allow-modals allow-orientation-lock allow-pointer-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation";
  return (
    <IFrame
      height='100vh'
      width='100%'
      text='GMU Pos'
      src={source}
      allowFullScreen={true}
      sandbox={sandBoxAttr}
      style={{ height: "100vh" }}
    />
  );
};

export default GmuFrame;
